<template>
  <!-- 第二步：准备具备大小的dom容器 -->
  <div id="main11"></div>
</template>

<script>
// 第一步：下载并引入echarts
import * as echarts from 'echarts';

export default {
  mounted() {
    // 第三步：基于准备好的dom，初始化echarts实例 echarts.init(dom容器)
    var myChart = echarts.init(document.getElementById('main11'));
    // 第四步：指定配置项option
  let option = {
        grid: {
  top: "8%",  // 图表距组件上边距离
 left:"5%"
},
  title: {
  
  },
  tooltip: {
    trigger: 'axis'
  },
   legend: {
                    orient: 'horizontal',
                    x: 'center',
                    y: 'top',
                    textStyle: {
                        fontSize: 14,
                    },
                    data: [
                        {
                            name: '可生成报告量',
                            textStyle: {
                                color: "#2B80FF "
                            }
                        },
                        {
                            name: '实际报告量',
                            textStyle: {
                                color: "#3DF3C4"
                            }
                        }
                    ],
                    backgroundColor: 'rgba(0,0,0,0)',
                    borderColor: '#ccc',
                    borderWidth: 0,
                    padding: 2,
                    itemGap: 20,
                    itemWidth: 20,
                    itemHeight: 14,
                },

  
  xAxis: {
    type: 'category',
    boundaryGap: true,
    data: ['1', '2', '3', '4', '5', '6', '7','8', '9', '10', '11', '12', '13','14', '15', '16', '17', '18', '19','20', '21', '22', '23', '24',   ]
  },
  yAxis: {
    type: 'value',
     axisLine: {                                    //坐标轴轴线设置
          show: true,                                  //是否显示坐标轴轴线
                                  //箭头大小        ([宽度,高度])
          symbolOffset: [0, 7],                      //箭头偏移
          lineStyle: {                                //坐标轴的线
            /* color: 'White',   */                          //线的颜色
            width: 3,                                //线的粗细程度    (用数字表示)
            type: 'solid',                            //线的类型        (可选solid  dotted  dashed)
            opacity:1                                //线的透明度        (用0~1的小数表示)
          }
        },
splitLine: {
              // 网格线
              show: true,
              lineStyle: { //分割线
              color: "#87CEFA40",
              width: 1,
              type: "solid" //dotted：虚线 solid:实线
             }
            },
     min:0, //y轴的最小值
    max:500, //y轴最大值 
    interval:100, //值之间的间隔
  },
  series: [
    {
      name: '可生成报告量',
 
      type: 'line',
      data: [100, 110, 130, 200, 120, 120, 90,100, 110, 130, 120, 160, 120, 180,150, 200, 130, 110, 150, 120, 160,200,250,300],
      markPoint: {
        data: [
          { type: 'max', name: 'Max' },
          { type: 'min', name: 'Min' }
        ]
      },
      markLine: {
        data: [{ type: 'average', name: 'Avg' }]
      }
    },
    {
      name: '实际报告量',
      type: 'line',
      data: [80, 100, 110, 160, 100, 110, 60,80, 100, 80, 90, 110, 60, 150,100, 140, 60, 80, 90,60, 120,150,170,250],
      markPoint: {
        data: [{ name: '周最低', value: -2, xAxis: 1, yAxis: -1.5 }]
      },
     
    }
  ]
};


  
    // 第五步：绘制图表，把配置项给实例对象
    myChart.setOption(option);
  }
}
</script>

<style>
/* 第二步 */
#main11 {
  width: 1000px;
  height: 320px;
  
}
</style>
